import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction, from } from 'rxjs';
import { catchError, exhaustMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { RootState } from '@redux/types';
import { GlobalSettingsType } from '@appTypes/globalSettingsType';
import { Actions, actions } from '@redux/modules/globalSettings';
import { TypedEpic } from './types';

export const fetchGlobalSettingsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_GLOBALSETTINGS),
    withLatestFrom(state$) as OperatorFunction<
      Action<any>,
      [ActionType<typeof actions.getGlobalSettings.request>, RootState]
    >,
    filter(([, state]) => !state.globalSettings.hasFetched),
    exhaustMap(([action]) =>
      from(
        apiClient.get<GlobalSettingsType>(ApiType.apimNafNoApi, {
          url: ApiPaths[ApiType.apimNafNoApi].globalSettings,
        }),
      ).pipe(
        map((response) => actions.getGlobalSettings.success(response.data)),
        catchError((err) =>
          of(
            actions.getGlobalSettings.failure(toReduxError(err, 'Could not get globalsettings'), {
              id: action.payload,
            }),
          ),
        ),
      ),
    ),
  );

export const epics: TypedEpic[] = [fetchGlobalSettingsEpic];
